// extracted by mini-css-extract-plugin
export var buttonContainer = "_37-6";
export var centeredToolbar = "_37-4";
export var dashdraw = "_37-c";
export var emptyStateContainer = "_37-8";
export var emptyStateText = "_37-9";
export var flowEditor = "_37-0";
export var flowEditorContainer = "_37-7";
export var hovered = "_37-1";
export var leftPanel = "_37-3";
export var mainCanvasContainer = "_37-a";
export var minimap = "_37-b";
export var selectMode = "_37-2";
export var toolbarSeparator = "_37-5";